
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import dayjs from 'dayjs'
import SearchOnlyPeriod from '~/components/Common/UI/Search/SearchOnlyPeriod'
import { isEmptyObject } from '~/utils/'
import api from '~/api/'
export default {
    components: {
        SearchOnlyPeriod,
    },
    data() {
        return {
            newsType: 'MENU_NEW_STOCK_OPINION',
            visibliltyList: true,
            original: [],
            short: [],
        }
    },
    computed: {
        ...mapState('research', ['report']),
        ...mapGetters('research', ['getStockfirmArr']),
        ...mapGetters('search', ['getSearch']),
        sortList() {
            return this.visibliltyList && this.original.length !== 0
        },
        originalList() {
            return !this.visibliltyList && this.original.length !== 0
        },
        /* 
            220314 meej
            더보기, 이전 버튼 : 글이 10개 이하 일 경우엔 안보이게 처리 
        */
        moreBtnChk() {
            return this.visibliltyList && this.original.length > 10
        },
        prevBtnChk() {
            return !this.visibliltyList && this.original.length > 10
        },
    },
    watch: {
        getSearch() {
            this.getList()
        },
    },
    mounted() {
         /* 
            220314 meej
            초기값 : 일주일 기간 설정
        */
        this.getSearch.startDate = dayjs(new Date()).subtract(7,'days').format('YYYYMMDD')
        this.getSearch.endDate = dayjs(new Date()).format('YYYYMMDD')
        
        this.getList()
    },

    methods: {
        ...mapActions('research', ['GET_NEW_REPORT']),
        async getList() {
            const data = await this.GET_NEW_REPORT({
                menuType: this.newsType,
                ...this.getSearch,
            })
            if (!isEmptyObject(data)) {
                this.original = data
                console.log(this.original)
                this.defaultList()
            }
        },
        onClickMoreTr(id) {
            const dsp = document.querySelectorAll(`.${id}`)
            for (const value of dsp) {
                if (value.style.display !== 'none') {
                    value.style.display = 'none'
                } else {
                    value.style.display = 'table-row'
                }
            }
        },
        onClickVisible() {},
        listSwich() {
            this.visibliltyList = !this.visibliltyList
        },
        defaultList() {
            /* 초기 더보기 누르기전 리스트 
                220314 meej 
                5 -> 10개로 변경
            */
            if (this.original.length !== 0) {
                const arrLeng = this.original.length
                if (arrLeng < 10) {
                    this.short = this.original
                } else {
                    this.short = []
                    this.moreBtn = true
                    for (let i = 0; i < 10; i++) {
                        this.short.push(this.original[i])
                    }
                }
            }
        },
        onClickStock(code) {
            const routeData = this.$router.resolve({
                name: `/stockitem?code=${code}`,
            })
            window.open(
                routeData.location.name,
                'StockItem',
                'width=1200px,height=1000,scrollbars=1,resizable=yes'
            )
        },
    },
}
